import React from "react";
import { Box, useTheme } from "@mui/material";
import Typography from "components/basic/typography";

import ConversationPreview from "../ConversationPreview";
import { ConversationView } from "../../types";

interface ConversationListProps {
  conversations: ConversationView[];
  selectedId: number | null;
  emptyText: string;
  onSelect: (conversation: ConversationView) => void;
  onToggleStar: (conversation: ConversationView) => void;
  onToggleArchive: (conversation: ConversationView) => void;
}

const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  selectedId,
  emptyText,
  onSelect,
  onToggleStar,
  onToggleArchive,
}) => {
  const theme = useTheme();

  if (conversations.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography
          variant="body2"
          style={{ color: theme.palette.text.secondary }}
        >
          {emptyText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {conversations.map((conversation) => (
        <ConversationPreview
          key={conversation.id}
          conversation={conversation}
          selected={conversation.id === selectedId}
          onClick={() => onSelect(conversation)}
          onToggleStar={() => onToggleStar(conversation)}
          onToggleArchive={() => onToggleArchive(conversation)}
        />
      ))}
    </Box>
  );
};

export default ConversationList;
